module.exports = __webpack_public_path__ + "img/1-prehistoire-img.cb082998.png";